/* ==========================================================
   CARTA NOOR — theme.js v2
   All JS in one file. No dependencies.
   ========================================================== */

(function () {
  'use strict';

  /* ──────────────────────────────────────────
     CUSTOM CURSOR
  ────────────────────────────────────────── */
  const cursor = document.getElementById('cn-cursor');
  if (cursor) {
    let mx = -100, my = -100;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });
    document.querySelectorAll('a, button, .fc-card, .product-card, .blog-card, label[for]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('cursor--expanded'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('cursor--expanded'); });
    });
  }

  /* ──────────────────────────────────────────
     SCROLL REVEAL
  ────────────────────────────────────────── */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ──────────────────────────────────────────
     STICKY HEADER
  ────────────────────────────────────────── */
  var header = document.getElementById('cnHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ──────────────────────────────────────────
     MOBILE DRAWER
  ────────────────────────────────────────── */
  var menuToggle  = document.getElementById('cnMenuToggle');
  var mobileDrawer = document.getElementById('cnMobileDrawer');

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.removeAttribute('hidden');
    mobileDrawer.classList.add('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // Focus first link
    var firstLink = mobileDrawer.querySelector('a, button');
    if (firstLink) setTimeout(function () { firstLink.focus(); }, 50);
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // After transition, hide
    setTimeout(function () {
      if (!mobileDrawer.classList.contains('is-open')) {
        mobileDrawer.setAttribute('hidden', '');
      }
    }, 400);
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileDrawer && !mobileDrawer.hasAttribute('hidden');
      isOpen ? closeDrawer() : openDrawer();
    });
  }

  if (mobileDrawer) {
    mobileDrawer.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-drawer-close') || e.target.closest('[data-drawer-close]')) {
        closeDrawer();
      }
    });
    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileDrawer && !mobileDrawer.hasAttribute('hidden')) {
        closeDrawer();
        if (menuToggle) menuToggle.focus();
      }
    });
  }

  /* ──────────────────────────────────────────
     QUIZ MODAL
  ────────────────────────────────────────── */
  var quizModal = document.getElementById('cnQuizModal');
  var quizInner = document.getElementById('cnQuizInner');

  // Quiz data
  var QUIZ_PRODUCTS = [];
fetch('/collections/all/products.json?limit=50')
  .then(function(r) { return r.json(); })
  .then(function(data) {
    QUIZ_PRODUCTS = data.products.map(function(p) {
      return {
        title:          p.title,
        handle:         p.handle,
        featured_image: p.images.length > 0 ? p.images[0].src : null,
        colours:        [],
        patterns:       []
      };
    });
  })
  .catch(function() {
    QUIZ_PRODUCTS = [];
  });


  var QUIZ_STEPS = [
    {
      key: 'room',
      question: 'Which room are you designing?',
      cols: 2,
      options: [
        { value: 'living-room',   label: 'Living Room' },
        { value: 'bedroom',       label: 'Bedroom' },
        { value: 'dining-room',   label: 'Dining Room' },
        { value: 'hallway',       label: 'Hallway / Entrance' },
        { value: 'home-office',   label: 'Home Office' },
        { value: 'hospitality',   label: 'Hospitality / Commercial' }
      ]
    },
    {
      key: 'colour',
      question: 'What colour palette speaks to you?',
      cols: 1,
      options: [
        { value: 'jewel-tones',  label: 'Jewel Tones',      desc: 'Rich sapphires, emeralds & rubies' },
        { value: 'neutrals',     label: 'Neutrals',          desc: 'Soft creams, stone & warm whites' },
        { value: 'dark-dramatic',label: 'Dark & Dramatic',   desc: 'Midnight, charcoal & deep indigo' },
        { value: 'warm-earth',   label: 'Warm Earth Tones',  desc: 'Terracotta, amber & spice' }
      ]
    },
    {
      key: 'pattern',
      question: 'What pattern mood draws you in?',
      cols: 1,
      options: [
        { value: 'geometric',    label: 'Geometric & Structured', desc: 'Precise lines, stars & lattice' },
        { value: 'botanical',    label: 'Botanical & Organic',    desc: 'Lush florals, leaves & garden scenes' },
        { value: 'architectural',label: "Architectural & Trompe l'Œil", desc: 'Arches, columns & illusion of depth' },
        { value: 'scenic',       label: 'Scenic & Narrative',     desc: 'Panoramic landscapes & storytelling' },
        { value: 'subtle-tonal', label: 'Subtle & Tonal',         desc: 'Tone-on-tone texture & quiet elegance' }
      ]
    },
    {
      key: 'coverage',
      question: 'How will the wallpaper live in your space?',
      cols: 1,
      options: [
        { value: 'feature-wall', label: 'Feature Wall',    desc: 'One statement wall as a focal point' },
        { value: 'full-room',    label: 'Full Room Wrap',  desc: 'Immersive all-around coverage' }
      ]
    }
  ];

  // Fallback products list (used if no real Shopify products injected)
  var FALLBACK_PRODUCTS = [
    { title: 'Alhambra Geometric',        handle: 'alhambra-geometric-luxury-geometric-wallpaper',        colours: ['jewel-tones','dark-dramatic'], patterns: ['geometric'] },
    { title: 'Persian Garden Tapestry',   handle: 'persian-garden-tapestry-luxury-scenic-wallpaper',      colours: ['jewel-tones','warm-earth'],    patterns: ['scenic','botanical'] },
    { title: 'Ottoman Tulip Cascade',     handle: 'ottoman-tulip-cascade-floral-luxury-wallpaper',        colours: ['warm-earth'],                  patterns: ['botanical'] },
    { title: 'Mughal Jungle',             handle: 'mughal-jungle-exotic-garden-luxury-wallpaper',          colours: ['jewel-tones'],                 patterns: ['botanical'] },
    { title: 'Andalusian Courtyard',      handle: 'andalusian-courtyard-mediterranean-luxury-wallpaper',  colours: ['warm-earth'],                  patterns: ['scenic','botanical'] },
    { title: 'Gothic Tracery',            handle: 'gothic-tracery-architectural-luxury-wallpaper',         colours: ['dark-dramatic'],               patterns: ['architectural','geometric'] },
    { title: 'Mughal Jali Screen',        handle: 'mughal-jali-screen-lattice-luxury-wallpaper',          colours: ['neutrals'],                    patterns: ['geometric','subtle-tonal'] },
    { title: 'Astral Meridian',           handle: 'the-astral-meridian-celestial-luxury-wallpaper',       colours: ['dark-dramatic'],               patterns: ['geometric','subtle-tonal'] },
    { title: 'Damask of the Dunes',       handle: 'damask-of-the-dunes-neutral-luxury-wallpaper',         colours: ['neutrals'],                    patterns: ['subtle-tonal','geometric'] },
    { title: 'Artisanal Zellige',         handle: 'artisanal-zellige-moroccan-luxury-tile-wallpaper',     colours: ['warm-earth'],                  patterns: ['geometric','subtle-tonal'] }
  ];

  var quizStep    = 0;  // 0 = splash, 1-4 = steps, 5 = results
  var quizAnswers = {};

  function openQuiz() {
    if (!quizModal) return;
    quizModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    quizStep    = 0;
    quizAnswers = {};
    renderQuiz();
    // Focus panel
    var panel = quizModal.querySelector('.quiz-modal__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 60);
  }

  function closeQuiz() {
    if (!quizModal) return;
    quizModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function renderQuiz() {
    if (!quizInner) return;
    if (quizStep === 0) {
      renderQuizSplash();
    } else if (quizStep <= QUIZ_STEPS.length) {
      renderQuizStep(QUIZ_STEPS[quizStep - 1]);
    } else {
      renderQuizResults();
    }
  }

  function renderQuizSplash() {
    quizInner.innerHTML =
      '<div class="quiz-start">' +
        '<p class="quiz-logo">✦ &nbsp;Carta Noor&nbsp; ✦</p>' +
        '<h2 class="quiz-title" id="quizModalTitle">Discover Your<br>Perfect Wallpaper</h2>' +
        '<p class="quiz-intro">Answer four questions and we\'ll match you with the designs that best suit your space, palette, and aesthetic.</p>' +
        '<button class="btn btn--quiz-large" id="quizStartBtn">Begin the quiz</button>' +
      '</div>';

    var startBtn = quizInner.querySelector('#quizStartBtn');
    if (startBtn) startBtn.addEventListener('click', function () {
      quizStep = 1;
      renderQuiz();
    });
  }

  function renderQuizStep(step) {
    var pct = Math.round(((quizStep - 1) / QUIZ_STEPS.length) * 100);
    var isTwoCols = step.cols === 2;

    var optionsHTML = step.options.map(function (opt) {
      var isSelected = quizAnswers[step.key] === opt.value;
      return (
        '<button class="quiz-option-btn' + (isSelected ? ' quiz-option-btn--selected' : '') + '" ' +
          'data-key="' + step.key + '" data-value="' + opt.value + '">' +
          '<span class="quiz-option-label">' + opt.label + '</span>' +
          (opt.desc ? '<span class="quiz-option-desc">' + opt.desc + '</span>' : '') +
        '</button>'
      );
    }).join('');

    quizInner.innerHTML =
      '<div class="quiz-progress">' +
        '<div class="quiz-progress__labels">' +
          '<span>Step ' + quizStep + ' of ' + QUIZ_STEPS.length + '</span>' +
          '<span class="quiz-progress__pct">' + pct + '%</span>' +
        '</div>' +
        '<div class="quiz-progress__bar-bg">' +
          '<div class="quiz-progress__bar-fill" style="width:' + pct + '%"></div>' +
        '</div>' +
      '</div>' +
      '<h2 class="quiz-question">' + step.question + '</h2>' +
      '<div class="quiz-options' + (isTwoCols ? '' : ' quiz-options--single') + '">' +
        optionsHTML +
      '</div>' +
      (quizStep > 1
        ? '<button class="quiz-back-btn" id="quizBackBtn">← Back</button>'
        : '');

    // Bind option buttons
    quizInner.querySelectorAll('.quiz-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var val = btn.getAttribute('data-value');
        quizAnswers[key] = val;
        // Brief highlight then advance
        btn.classList.add('quiz-option-btn--selected');
        setTimeout(function () {
          quizStep++;
          renderQuiz();
        }, 180);
      });
    });

    var backBtn = quizInner.querySelector('#quizBackBtn');
    if (backBtn) backBtn.addEventListener('click', function () {
      quizStep = Math.max(1, quizStep - 1);
      renderQuiz();
    });
  }

  function scoreProduct(product) {
    var score = 0;
    var colours  = product.colours  || product.tags_colours  || [];
    var patterns = product.patterns || product.tags_patterns || [];

    if (quizAnswers.colour  && colours.indexOf(quizAnswers.colour)   > -1) score += 2;
    if (quizAnswers.pattern) {
      if (patterns[0] === quizAnswers.pattern)                             score += 2;
      else if (patterns.indexOf(quizAnswers.pattern) > -1)                score += 1;
    }
    return score;
  }

function renderQuizResults() {
    // Show loading state while images fetch
    if (QUIZ_PRODUCTS.length === 0) {
      quizInner.innerHTML = '<div class="quiz-loading"><p>✦ &nbsp;Finding your perfect match&nbsp; ✦</p></div>';
      var checkReady = setInterval(function() {
        if (QUIZ_PRODUCTS.length > 0) {
          clearInterval(checkReady);
          renderQuizResults();
        }
      }, 100);
      return;
    }

    var pool = FALLBACK_PRODUCTS.map(function(fp) {
      var match = QUIZ_PRODUCTS.find(function(qp) { return qp.handle === fp.handle; });
      return match ? Object.assign({}, fp, { featured_image: match.featured_image }) : fp;
    });


    var scored = pool.map(function (p) { return { p: p, s: scoreProduct(p) }; });
    scored.sort(function (a, b) { return b.s - a.s; });
    var top3 = scored.slice(0, 3).map(function (x) { return x.p; });

    var cardsHTML = top3.map(function (p) {
      var url    = '/products/' + p.handle;
      var imgTag = p.featured_image
        ? '<img src="' + (p.featured_image.src || p.featured_image) + '" alt="' + p.title + '" style="width:100%;height:100%;object-fit:cover;">'


        : '<p class="quiz-result-card__placeholder">' + p.title + '</p>';

      return (
        '<div class="quiz-result-card">' +
          '<div class="quiz-result-card__img">' + imgTag + '</div>' +
          '<div class="quiz-result-card__body">' +
            '<p class="quiz-result-card__name">' + p.title + '</p>' +
            '<a href="' + url + '" class="quiz-result-card__view">View design</a>' +
            '<a href="' + url + '?intent=sample" class="quiz-result-card__sample">Order sample</a>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    quizInner.innerHTML =
      '<div class="quiz-results-header">' +
        '<p class="quiz-logo">✦ &nbsp;Your style match&nbsp; ✦</p>' +
        '<h2 class="quiz-title">Your Curated Selection</h2>' +
        '<p class="quiz-intro">Based on your answers, we recommend these designs from the Carta Noor collection.</p>' +
      '</div>' +
      '<div class="quiz-results-grid">' + cardsHTML + '</div>' +
      '<button class="quiz-restart-btn" id="quizRestart">↺ Start over</button>';

    var restartBtn = quizInner.querySelector('#quizRestart');
    if (restartBtn) restartBtn.addEventListener('click', function () {
      quizStep    = 0;
      quizAnswers = {};
      renderQuiz();
    });
  }

  // Wire all quiz open triggers
  function wireQuizTriggers() {
    var triggers = document.querySelectorAll(
      '#cnQuizOpen, #cnQuizOpenMobile, #cnQuizOpenSection, .site-header__quiz-btn, .mobile-drawer__quiz-btn'
    );
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer();
        openQuiz();
      });
    });
  }

  if (quizModal) {
    // Close on backdrop / close button
    quizModal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-quiz-close') || e.target.closest('[data-quiz-close]')) {
        closeQuiz();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !quizModal.hasAttribute('hidden')) closeQuiz();
    });
    wireQuizTriggers();
  }

  // Expose globally for inline onclick="" fallbacks
  window.openQuiz  = openQuiz;
  window.closeQuiz = closeQuiz;

  /* ──────────────────────────────────────────
     PRODUCT PAGE — Gallery
  ────────────────────────────────────────── */
  var galleryMain   = document.getElementById('PGMain');
  var galleryThumbs = document.querySelector('.product-gallery__thumbs');

  if (galleryMain && galleryThumbs) {
    var slides = galleryMain.querySelectorAll('.product-gallery__slide');
    var thumbs = galleryThumbs.querySelectorAll('.product-gallery__thumb');

    function activateSlide(idx) {
      slides.forEach(function (s) {
        s.classList.remove('product-gallery__slide--active');
        s.setAttribute('hidden', '');
      });
      thumbs.forEach(function (t) {
        t.classList.remove('product-gallery__thumb--active');
        t.setAttribute('aria-pressed', 'false');
      });
      var target = galleryMain.querySelector('[data-index="' + idx + '"]');
      if (target) {
        target.classList.add('product-gallery__slide--active');
        target.removeAttribute('hidden');
      }
      var targetThumb = galleryThumbs.querySelector('[data-target="' + idx + '"]');
      if (targetThumb) {
        targetThumb.classList.add('product-gallery__thumb--active');
        targetThumb.setAttribute('aria-pressed', 'true');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-target');
        activateSlide(idx);
      });
    });
  }

  /* ──────────────────────────────────────────
     PRODUCT PAGE — Variant Selection
  ────────────────────────────────────────── */
  var variantDataEl = document.querySelector('[id^="ProductVariants-"]');
  var variantIdInput = document.querySelector('[id^="ProductVariantId-"]');
  var priceDisplay   = document.getElementById('ProductPrice');
  var atcButton      = document.getElementById('ProductATC');

  if (variantDataEl && variantIdInput) {
    var allVariants = JSON.parse(variantDataEl.textContent);
    var radioGroups = document.querySelectorAll('.product-variant-group');

    function getSelectedOptions() {
      var opts = [];
      radioGroups.forEach(function (group) {
        var checked = group.querySelector('.product-variant-radio:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findMatchingVariant(selectedOpts) {
      return allVariants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOpts[i];
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      // Update hidden input
      variantIdInput.value = variant.id;

      if (priceDisplay) {
  // Get the active currency
  var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    ? window.Shopify.currency.active
    : 'HUF';

  // Find the presentment price for the active currency
  var presentment = variant.presentment_prices && variant.presentment_prices.find(function(p) {
    return p.price.currency_code === activeCurrency;
  });

  var displayPrice = presentment ? Math.round(parseFloat(presentment.price.amount) * 100) : variant.price;
  var comparePrice = presentment && presentment.compare_at_price
    ? Math.round(parseFloat(presentment.compare_at_price.amount) * 100)
    : variant.compare_at_price;

  var compareHTML = comparePrice && comparePrice > displayPrice
    ? '<s class="product-price__compare">' + formatMoney(comparePrice) + '</s>'
    : '';

  priceDisplay.innerHTML =
    compareHTML +
    '<span class="product-price__current">' + formatMoney(displayPrice) + '</span>';
}


      // Update ATC button
      if (atcButton) {
        if (variant.available) {
          atcButton.disabled = false;
          atcButton.textContent = (window.CN_T && window.CN_T.atc) || 'Add to Cart';
        } else {
          atcButton.disabled = true;
          atcButton.textContent = (window.CN_T && window.CN_T.sold_out) || 'Sold Out';
        }
      }

      // Update gallery if variant has image
      if (variant.featured_image && galleryMain) {
        var imgSrc = variant.featured_image.src;
        // Find matching slide
        var matchSlide = Array.from(galleryMain.querySelectorAll('.product-gallery__slide')).find(function (sl) {
          var img = sl.querySelector('img');
          return img && img.src && img.src.includes(imgSrc.split('?')[0].split('/').pop().split('.')[0].substring(0, 20));
        });
        if (matchSlide) {
          activateSlide(matchSlide.getAttribute('data-index'));
        }
      }
    }

    radioGroups.forEach(function (group) {
      group.querySelectorAll('.product-variant-radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var selectedOpts = getSelectedOptions();
          var match = findMatchingVariant(selectedOpts);
          if (match) updateVariantUI(match);
        });
      });
    });
  }

  /* ──────────────────────────────────────────
     PRODUCT PAGE — Quantity Buttons
  ────────────────────────────────────────── */
  var qtyInput = document.getElementById('ProductQty');
  if (qtyInput) {
    document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-qty-change'), 10);
        var curr = parseInt(qtyInput.value, 10) || 1;
        var next = Math.max(1, curr + dir);
        qtyInput.value = next;
      });
    });
  }

  /* ──────────────────────────────────────────
     PRODUCT PAGE — ATC with error handling
  ────────────────────────────────────────── */
  var productForm = document.querySelector('[id^="ProductForm-"]');
  var productError = document.getElementById('ProductError');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcButton) {
        atcButton.disabled = true;
        atcButton.textContent = 'Adding…';
      }

      var formData = new FormData(productForm);
      var data = {};
      formData.forEach(function (val, key) { data[key] = val; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: data.id, quantity: parseInt(data.quantity, 10) || 1 })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function () {
        // Update cart count in header
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.site-header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            var cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'site-header__cart-count';
              span.setAttribute('aria-hidden', 'true');
              cartLink.appendChild(span);
              countEl = span;
            }
          }
          if (countEl) countEl.textContent = cart.item_count;
        }
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.textContent = (window.CN_T && window.CN_T.added) || 'Added ✓';
          setTimeout(function () { atcButton.textContent = (window.CN_T && window.CN_T.atc) || 'Add to Cart'; }, 2000);
        }
        if (productError) productError.setAttribute('hidden', '');
      })
      .catch(function (err) {
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.textContent = (window.CN_T && window.CN_T.atc) || 'Add to Cart';
        }
        if (productError) {
          var msg = (err && err.description) || 'Could not add to cart. Please try again.';
          productError.textContent = msg;
          productError.removeAttribute('hidden');
        }
      });
    });
  }

  /* ──────────────────────────────────────────
     CART PAGE — Qty & Remove (AJAX)
  ────────────────────────────────────────── */
  var cartItems = document.getElementById('CartItems');
  var cartSubtotal = document.getElementById('CartSubtotal');

  function updateCart(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      // Reload page to reflect updated cart — simple and reliable
      window.location.reload();
    })
    .catch(function () {
      window.location.reload();
    });
  }

  if (cartItems) {
    // Qty change buttons
    cartItems.addEventListener('click', function (e) {
      var changeBtn = e.target.closest('[data-cart-qty-change]');
      if (changeBtn) {
        var key = changeBtn.getAttribute('data-cart-qty-change');
        var dir = parseInt(changeBtn.getAttribute('data-direction'), 10);
        var input = cartItems.querySelector('[data-cart-qty-input="' + key + '"]');
        if (input) {
          var newQty = Math.max(0, parseInt(input.value, 10) + dir);
          input.value = newQty;
          updateCart(key, newQty);
        }
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var removeKey = removeBtn.getAttribute('data-cart-remove');
        updateCart(removeKey, 0);
      }
    });

    // Direct input change
    cartItems.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (input) {
        var key = input.getAttribute('data-cart-qty-input');
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        updateCart(key, qty);
      }
    });
  }

  /* ──────────────────────────────────────────
     COLLECTION PAGE — Sort
  ────────────────────────────────────────── */
  var sortSelect = document.querySelector('.collection-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ──────────────────────────────────────────
     ANNOUNCEMENT MARQUEE — duplicate for seamless loop
  ────────────────────────────────────────── */
  var annTrack = document.getElementById('annTrack');
  if (annTrack && annTrack.children.length > 0) {
    // Already duplicated in Liquid for seamless loop — no JS needed
    // If only one copy, duplicate:
    if (annTrack.scrollWidth <= annTrack.parentElement.clientWidth * 1.2) {
      annTrack.innerHTML += annTrack.innerHTML;
    }
  }

  /* ──────────────────────────────────────────
     HELPER — Format money (Shopify cents → £x.xx)
  ────────────────────────────────────────── */
 function formatMoney(cents) {
  if (typeof cents === 'string') cents = parseInt(cents.replace('.', ''), 10);
  
  var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    ? window.Shopify.currency.active
    : 'HUF';

  var currencySymbols = {
    'HUF': '',
    'GBP': '£',
    'EUR': '€',
    'USD': '$',
    'AED': 'AED ',
    'AUD': 'A$',
    'JPY': '¥',
    'SGD': 'S$',
    'MYR': 'RM',
    'INR': '₹',
    'CAD': 'CA$'
  };

  var symbol = currencySymbols[activeCurrency] !== undefined ? currencySymbols[activeCurrency] : activeCurrency + ' ';
  var amount = (cents / 100).toFixed(activeCurrency === 'HUF' || activeCurrency === 'JPY' ? 0 : 2);
  
  // HUF shows amount first, then Ft
  if (activeCurrency === 'HUF') return amount + ' Ft';
  
  return symbol + amount;
}



  /* ──────────────────────────────────────────
     SMOOTH ANCHOR SCROLL
  ────────────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href').slice(1);
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  });

  /* ──────────────────────────────────────────
     FAQ — close others on open (optional UX)
  ────────────────────────────────────────── */
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item && other.open) other.removeAttribute('open');
        });
      }
    });
  });

})();
